module.exports = __webpack_public_path__ + "img/payform-logo.ada4f3b0.png";